module.exports = {
    "admin.user.list": "Xem danh sách",
    "admin.user.create": "Thêm mới",
    "admin.user.detail": "Xem chi tiết",
    "admin.user.update": "Cập nhật thông tin",
    "admin.user.remove": "Xoá",

    "admin.permissions.list": "Xem danh sách quyền",
    "admin.permissions.update": "Phân quyền",
    "admin.permissions.get_by_role": "Lấy danh sách quyền theo vai trò",
    "admin.permissions.get_by_user": "Lấy danh sách quyền theo nhân viên",

    "admin.config.update": "Cấu hình email hệ thống",

    "admin.services.list": "Xem danh sách",
    "admin.services.create": "Thêm mới",
    "admin.services.update": "Cập nhật",
    "admin.services.remove": "Xóa",

    "admin.customer_class.list": "Xem danh sách",
    "admin.customer_class.create": "Thêm mới",
    "admin.customer_class.update": "Cập nhật",
    "admin.customer_class.remove": "Xóa",

    "admin.relationship_types.list": "Xem danh sách",
    "admin.relationship_types.create": "Thêm mới",
    "admin.relationship_types.update": "Cập nhật",
    "admin.relationship_types.remove": "Xóa",

    "admin.customer_status.list": "Xem danh sách",
    "admin.customer_status.create": "Thêm mới",
    "admin.customer_status.update": "Cập nhật",
    "admin.customer_status.remove": "Xóa",

    "admin.interaction_statuses.list": "Xem danh sách",
    "admin.interaction_statuses.create": "Thêm mới",
    "admin.interaction_statuses.update": "Cập nhật",
    "admin.interaction_statuses.remove": "Xóa",

    "admin.interaction_types.list": "Xem danh sách",
    "admin.interaction_types.create": "Thêm mới",
    "admin.interaction_types.update": "Cập nhật",
    "admin.interaction_types.remove": "Xóa",

    "admin.customer.list": "Xem danh sách",
    "admin.customer.orthodontic_customer": "Xem danh sách khách chỉnh nha",
    "admin.customer.create": "Thêm mới",
    "admin.customer.import_excel": "Import từ excel",
    "admin.customer.detail": "Xem chi tiết",
    "admin.customer.update": "Cập nhật",
    "admin.customer.remove": "Xóa",
    "admin.customer.phonenumber": "Xem số điện thoại",
    "admin.customer.voicecall": "Gọi điện thoại cho khách",
    "admin.customer.create_from_chat": "Tạo khách hàng từ form chat",
    "admin.customer.update_from_chat": "Cập nhật khách hàng từ form chat",
    "admin.customer.update_media": "Cập nhật ảnh tình trạng hiện tại",
    "admin.customer.transfer_to_staff": "Giao khách hàng cho telesale",
    "admin.customer.payment_history": "Xem lịch sử thanh toán",
    "admin.customer.input_pin_code": "Xem số điện thoại bằng mã PIN",
    "admin.customer.phonenumber_update": "Cập nhật số điện thoại",
    "admin.customer.update_image_profile": "Cập nhật ảnh hồ sơ",
    "admin.customer.remove_image_profile": "Xóa ảnh hồ sơ",
    "admin.customer.export": "Xuất file",
    "admin.customer.set_primary_phone": "Cập nhật số điện thoại chính",
    "admin.customer.view_finance": "Xem thông tin tài chính",


    "admin.customer_services.list": "Xem danh sách",
    "admin.customer_services.create": "Tạo mới",
    "admin.customer_services.update": "Cập nhật",
    "admin.customer_services.remove": "Xóa",
    "admin.customer_services.detail": "Xem chi tiết",
    "admin.customer_services.create_exam_visit": "Thêm lần khám",
    "admin.customer_services.update_exam_visit": "Cập nhật lần khám",
    "admin.customer_services.exam_visit_remove": "Xóa lần khám",
    "admin.customer_services.export": "Xuất file",
    "admin.customer_services.convert_to_service": "Chuyển đổi dịch vụ sang dịch vụ khác",

    "admin.partner_customers.list": "Xem danh sách",

    "admin.customer_source.list": "Xem danh sách",
    "admin.customer_source.create": "Thêm mới",
    "admin.customer_source.update": "Cập nhật",
    "admin.customer_source.remove": "Xóa",

    "admin.page_manager.list": "Danh sách trang",
    "admin.page_manager.connect_facebook": "Thực hiện kết nối facebook",
    "admin.page_manager.update": "Cập nhật trang",
    "admin.page_manager.update_status": "Kích hoạt trang",

    "admin.branches.list": "Xem danh sách",
    "admin.branches.create": "Thêm mới",
    "admin.branches.detail": "Xem chi tiết",
    "admin.branches.update": "Cập nhật",
    "admin.branches.remove": "Xóa",
    "admin.branches.remove_image": "Xóa ảnh cơ sở",

    "admin.role_groups.list": "Xem danh sách",
    "admin.role_groups.create": "Thêm mới",
    "admin.role_groups.update": "Cập nhật",
    "admin.role_groups.remove": "Xóa",

    "admin.roles.list": "Xem danh sách",
    "admin.roles.create": "Thêm mới",
    "admin.roles.update": "Cập nhật",
    "admin.roles.remove": "Xóa",

    "admin.appointment.list": "Xem danh sách",
    "admin.appointment.create": "Thêm mới",
    "admin.appointment.detail": "Xem chi tiết",
    "admin.appointment.update": "Cập nhật",
    "admin.appointment.remove": "Xóa",
    "admin.appointment.update_status": "Cập nhật trạng thái lịch hẹn",
    "admin.appointment.transfer_to_staff": "Giao lịch hẹn cho nhân viên sales",
    "admin.appointment.move_appointment": "Chuyển lịch hẹn",
    "admin.appointment.after_service_care_update": "Cập nhật CSKH sau dịch vụ",
    "admin.appointment.export": "Xuất file excel",

    "admin.diseases.list": "Xem danh sách",
    "admin.diseases.create": "Thêm mới",
    "admin.diseases.update": "Cập nhật",
    "admin.diseases.remove": "Xóa",

    "admin.blood_groups.list": "Xem danh sách",
    "admin.blood_groups.create": "Thêm mới",
    "admin.blood_groups.update": "Cập nhật",
    "admin.blood_groups.remove": "Xóa",

    "admin.product_warehouse.list": "Xem danh sách",
    "admin.product_warehouse.create": "Thêm mới",
    "admin.product_warehouse.update": "Cập nhật",
    "admin.product_warehouse.remove": "Xóa",

    "admin.product_group.list": "Xem danh sách",
    "admin.product_group.create": "Thêm mới",
    "admin.product_group.update": "Cập nhật",
    "admin.product_group.remove": "Xóa",

    "admin.product.list": "Xem danh sách",
    "admin.product.detail": "Xem chi tiết",
    "admin.product.update": "Cập nhật",
    "admin.product.remove": "Xóa",
    "admin.product.statistics": "Xem thống kê tồn kho",
    "admin.product.stats_export": "Xuất file excel thống kê",

    "admin.product_receipt_import.list": "Xem danh sách",
    "admin.product_receipt_import.create": "Thêm mới",
    "admin.product_receipt_import.detail": "Xem chi tiết",
    'admin.product_receipt_import.update': "Cập nhật",
    "admin.product_receipt_import.export": "Xuất file excel",
    'admin.product_receipt_import.remove': "Xóa",

    "admin.product_receipt_export.list": "Xem danh sách",
    "admin.product_receipt_export.create": "Thêm mới",
    "admin.product_receipt_export.update": "Cập nhật",
    "admin.product_receipt_export.detail": "Xem chi tiết",
    "admin.product_receipt_export.export": "Xuất file excel",
    "admin.product_receipt_export.remove": "Xóa",

    'admin.product_supplier.list': "Xem danh sách",
    'admin.product_supplier.create': "Thêm mới",
    'admin.product_supplier.update': "Cập nhật",
    'admin.product_supplier.remove': "Xóa",

    'admin.unit.list': "Xem danh sách",
    'admin.unit.create': "Thêm mới",
    'admin.unit.update': "Cập nhật",
    'admin.unit.remove': "Xóa",

    'admin.product_status.list': "Xem danh sách",
    'admin.product_status.create': "Thêm mới",
    'admin.product_status.update': "Cập nhật",
    'admin.product_status.remove': "Xóa",

    "admin.guide.list": "Xem danh sách",
    "admin.guide.create": "Thêm mới",
    "admin.guide.detail": "Xem chi tiết",
    "admin.guide.update": "Cập nhật",
    "admin.guide.remove": "Xóa",

    "admin.work_report.list": "Xem danh sách",
    "admin.work_report.create": "Tạo mới",
    "admin.work_report.update": "Cập nhật",
    "admin.work_report.detail": "Xem chi tiết",
    "admin.work_report.remove": "Xóa",
    "admin.work_report.export": "Xuất file excel",

    "admin.lookup_customer.list": "Xem danh sách",
    "admin.lookup_customer.transfer_to_staff": "Giao khách hàng cho telesale",

    "admin.customer_prospect.list": "Xem danh sách",
    "admin.customer_prospect.create": "Thêm mới",
    "admin.customer_prospect.import_excel": "Import excel",
    "admin.customer_prospect.phonenumber": "Xem số điện thoại",
    "admin.customer_prospect.voicecall": "Gọi điện thoại cho khách",
    "admin.customer_prospect.update": "Cập nhật",
    "admin.customer_prospect.remove": "Xóa",
    "admin.customer_prospect.input_pin_code": "Xem số điện thoại bằng mã PIN",
    "admin.customer_prospect.export": "Xuất file excel",

    "admin.receipt.list": "Xem danh sách",
    "admin.receipt.create": "Tạo phiếu",
    "admin.receipt.detail": "Xem chi tiết",
    "admin.receipt.update": "Cập nhật",
    "admin.receipt.remove": "Xóa",
    "admin.receipt.update_status": "Cập nhật trạng thái phiếu",
    "admin.receipt.import_excel": "Import phiếu có sẵn",

    "admin.cash_book.list": "Xem danh sách",
    "admin.cash_book.export": "Xuất file excel",

    "admin.payment_voucher.list": "Xem danh sách",
    "admin.payment_voucher.create": "Tạo phiếu",
    "admin.payment_voucher.detail": "Xem chi tiết",
    "admin.payment_voucher.update": "Cập nhật",
    "admin.payment_voucher.remove": "Xóa",
    "admin.payment_voucher.update_status": "Cập nhật trạng thái phiếu",

    "admin.view_phonenumber.list": "Xem danh sách",
    "admin.view_phonenumber.phonenumber": "Xem số điện thoại",
    "admin.view_phonenumber.remove": "Xóa",

    "admin.messenger.thread": "Danh sách cuộc trò chuyện",
    "admin.messenger.message": "Xem chi tiết tin nhắn",
    "admin.messenger.send_message": "Gửi tin nhắn",
    "admin.messenger.update_customer": "Cập nhật khách hàng",
    "admin.messenger.customer_info": "Xem thông tin khách hàng",
    "admin.messenger.delete_comment": "Xóa bình luận",
    "admin.messenger.hide_comment": "Ẩn/Hiện bình luận",

    "admin.customer_group.list": "Xem danh sách",
    "admin.customer_group.create": "Thêm mới",
    "admin.customer_group.update": "Cập nhật",
    "admin.customer_group.remove": "Xóa",

    "admin.customer_payment.add": "Thêm mới",
    "admin.customer_payment.update": "Cập nhật",
    "admin.customer_payment.remove": "Xóa",

    "admin.additional_cost.add": "Thêm mới",
    "admin.additional_cost.update": "Cập nhật",
    "admin.additional_cost.remove": "Xóa",

    "admin.zalo.grant_permission": "Kết nối Zalo OA",
    "admin.zalo.list": "Xem danh sách Zalo OA",

    "admin.audit_logs.search": "Xem danh sách",
    "admin.audit_logs.rollback": "Rollback",
    "admin.audit_logs.detail": "Chi tiết",

    "admin.labos.list": "Xem danh sách",
    "admin.labos.create": "Tạo mới",
    "admin.labos.detail": "Xem chi tiết",
    "admin.labos.update": "Cập nhật",
    "admin.labos.remove": "Xóa",

    "admin.labo_cases.list": "Xem danh sách",
    "admin.labo_cases.create": "Tạo mới",
    "admin.labo_cases.detail": "Xem chi tiết",
    "admin.labo_cases.update": "Cập nhật",
    "admin.labo_cases.remove": "Xóa",
    "admin.labo_cases.status_statistics": "Xem thống kê theo trạng thái",
    "admin.labo_cases.customer_statistics": "Xem thống kê theo khách hàng",

    "admin.statistics.revenue": "Doanh thu & doanh số",
    "admin.statistics.staff_revenue_yearly": "Doanh số nhân viên (năm)",
    "admin.statistics.staff_revenue_detail": "Doanh số nhân viên chi tiết",
    "admin.statistics.staff_revenue_yearly_export": "Xuất excel doanh số nhân viên (năm)",
    "admin.statistics.staff_revenue_detail_export": "Xuất excel doanh số nhân viên chi tiết",
    "admin.statistics.assistants_support_cases": "Thống kê ca hỗ trợ của phụ tá",
    "admin.statistics.assistants_support_case_export": "Xuất excel ca hỗ trợ của phụ tá",
    "admin.statistics.assistants_support_case_export_all": "Export tổng hợp số ca phụ toàn bộ phụ tá",
    "admin.statistics.customer_visits": "Thống kê lượt khách đến theo nhóm dịch vụ",

    "admin.branch_fund.list": "Xem danh sách",
    "admin.branch_fund.create": "Thêm mới",
    "admin.branch_fund.update": "Cập nhật",
    "admin.branch_fund.detail": "Xem chi tiết",
    "admin.branch_fund.remove": "Xóa",

    "admin.procedures.list": "Xem danh sách",
    "admin.procedures.create": "Tạo mới",
    "admin.procedures.detail": "Xem chi tiết",
    "admin.procedures.update": "Cập nhật",
    "admin.procedures.remove": "Xóa",

    "admin.customer_care_categories.list": "Xem danh sách",
    "admin.customer_care_categories.create": "Tạo mới",
    "admin.customer_care_categories.detail": "Xem chi tiết",
    "admin.customer_care_categories.update": "Cập nhật",
    "admin.customer_care_categories.remove": "Xóa",

    "admin.customer_care_logs.list": "Xem danh sách",
    "admin.customer_care_logs.create": "Thêm mới",
    "admin.customer_care_logs.detail": "Xem chi tiết",
    "admin.customer_care_logs.update": "Cập nhật",
    "admin.customer_care_logs.remove": "Xóa",

    "admin.customer_complaints.list": "Xem danh sách",
    "admin.customer_complaints.create": "Thêm mới",
    "admin.customer_complaints.detail": "Xem chi tiết",
    "admin.customer_complaints.update": "Cập nhật",
    "admin.customer_complaints.remove": "Xóa",

    "admin.instruction_templates.list": "Xem danh sách",
    "admin.instruction_templates.create": "Tạo mới",
    "admin.instruction_templates.detail": "Xem chi tiết",
    "admin.instruction_templates.update": "Cập nhật",
    "admin.instruction_templates.remove": "Xóa",

    "admin.prescription_templates.list": "Xem danh sách",
    "admin.prescription_templates.create": "Tạo mới",
    "admin.prescription_templates.detail": "Xem chi tiết",
    "admin.prescription_templates.update": "Cập nhật",
    "admin.prescription_templates.remove": "Xóa",

    "admin.images.create_folder": "Tạo thư mục ảnh",
    "admin.images.update_folder": "Cập nhật thư mục ảnh",
    "admin.images.create_image": "Tải lên ảnh",
    "admin.images.delete_image": "Xóa ảnh",
    "admin.images.delete_folder": "Xóa thư mục ảnh",
    "admin.images.update_image": "Cập nhật ảnh",

    "admin.customer_refund.view": "Xem nguồn và lịch sử hoàn tiền khách hàng",
    "admin.customer_refund.execute": "Thực hiện hoàn tiền cho khách hàng",
    "admin.customer_deposit.receive": "Nhận tiền cọc",
    "admin.customer_deposit.view": "Xem tiền cọc khách hàng",
    "admin.customer_deposit.apply": "Sử dụng tiền cọc",
    "admin.customer_deposit.transfer": "Chuyển dịch vụ dự kiến",
    "admin.customer_deposit.adjust": "Điều chỉnh tiền cọc",
    "admin.customer_deposit.refund": "Trả cọc",

    "admin.milestones.list": "Xem danh sách",
    "admin.milestones.update": "Cập nhật",
    "admin.milestones.notify": "Gửi thống báo",

    // Bình luận chỉnh nha
    "admin.orthodontic_comments.create": "Tạo bình luận chỉnh nha",
    "admin.orthodontic_comments.update": "Cập nhật bình luận chỉnh nha",
    "admin.orthodontic_comments.delete": "Xóa bình luận chỉnh nha",

    // Bệnh án chỉnh nha
    "admin.orthodontic_plans.update": "Cập nhật bệnh án chỉnh nha",
    "admin.orthodontic_plans.approve": "Phê duyệt bệnh án chỉnh nha",
    "admin.orthodontic_plans.unapprove": "Hủy phê duyệt bệnh án chỉnh nha",

    // Khám tổng quát
    "admin.general_exams.create": "Tạo phiếu",
    "admin.general_exams.update": "Cập nhật phiếu",
    "admin.general_exams.approve": "Xác nhận phiếu",
    "admin.general_exams.unapprove": "Hủy xác nhận phiếu",
    'admin.general_exams.remove': 'Xoá',
    'admin.general_exams.detail': 'Xem chi tiết',

    // Khám chỉnh nha
    "admin.orthodontic_exams.create": "Tạo phiếu",
    "admin.orthodontic_exams.remove": "Xóa phiếu",
    "admin.orthodontic_exams.update": "Cập nhật phiếu",
    "admin.orthodontic_exams.approve": "Xác nhận phiếu",
    "admin.orthodontic_exams.unapprove": "Hủy xác nhận phiếu",

    'admin.treatment_sessions.list': 'Xem danh sách',
    'admin.treatment_sessions.create': 'Thêm mới',
    'admin.treatment_sessions.update': 'Cập nhật',
    'admin.treatment_sessions.toggle_orthodontic_status': 'Cập nhật trạng thái chỉnh nha',
    'admin.treatment_sessions.remove': 'Xoá',
    'admin.treatment_sessions.detail': 'Xem chi tiết',
    'admin.treatment_sessions.approve': 'Xác nhận phiếu',
    'admin.treatment_sessions.unapprove': 'Hủy xác nhận phiếu',

    'admin.medical_records.update': 'Cập nhật bệnh án',
    'admin.medical_records.approve': 'Xác nhận bệnh án',
    'admin.medical_records.unapprove': 'Hủy xác nhận bệnh án',

    "admin.telesale_follow_up.list": "Xem danh sách",
    "admin.telesale_follow_up.assign": "Giao khách hàng cho telesale",
    "admin.telesale_follow_up.update": "Cập nhật",
    "admin.telesale_follow_up.update_result": "Trả kết quả telesale",
    "admin.telesale_follow_up.delete": "Xóa",

    "admin.feedback_requests.list": "Xem danh sách",
    "admin.feedback_requests.create": "Tạo mới",
    "admin.feedback_requests.detail": "Xem chi tiết",
    "admin.feedback_requests.update": "Cập nhật",
    "admin.feedback_requests.remove": "Xóa",

    "admin.doctor_customers.list": "Xem danh sách",
    "admin.doctor_appointments.list": "Xem danh sách",

    "admin.monitorings.view": "Xem danh sách",

    // Hoa hồng
    "admin.commission.employee_commission_dashboard": "Xem hoa hồng cá nhân",

    // Điều chỉnh hoa hồng
    "admin.commission_adjustment.view": "Xem điều chỉnh",
    "admin.commission_adjustment.request": "Yêu cầu điều chỉnh",
    "admin.commission_adjustment.approve": "Duyệt điều chỉnh",

    // Thu hồi hoa hồng
    "admin.commission_recovery.view": "Xem thu hồi",
    "admin.commission_recovery.request": "Yêu cầu thu hồi",
    "admin.commission_recovery.approve": "Duyệt thu hồi",

    // Hoàn hoa hồng
    "admin.commission_refund.view": "Xem hoàn hoa hồng",
    "admin.commission_refund.request": "Yêu cầu hoàn hoa hồng",
    "admin.commission_refund.approve": "Duyệt hoàn hoa hồng",

    // Kết quả tính hoa hồng
    "admin.commission_result.calculate": "Tính hoa hồng",
    "admin.commission_result.view_trace": "Xem chi tiết tính toán",

    // Khoản hoa hồng đang giữ
    "admin.commission_hold.view": "Xem khoản đang giữ",
    "admin.commission_hold.care_outcome": "Cập nhật kết quả chăm sóc",

    // Kỳ hoa hồng
    "admin.commission_period.view": "Xem kỳ hoa hồng",
    "admin.commission_period.lock": "Khóa kỳ hoa hồng",

    // Tổng hợp hoa hồng
    "admin.commission_aggregate.finalize": "Chốt tổng hợp hoa hồng",

    // Đối soát hoa hồng
    "admin.commission_reconciliation.view": "Xem đối soát",
    "admin.commission_reconciliation.update": "Cập nhật đối soát",

    // Duyệt hoa hồng
    "admin.commission_approval.view": "Xem danh sách chờ duyệt",
    "admin.commission_approval.update": "Duyệt hoa hồng",

    // Chi trả hoa hồng
    "admin.commission_payout.view": "Xem chi trả",
    "admin.commission_payout.pay": "Thực hiện chi trả",
    "admin.commission_payout.history": "Xem lịch sử chi trả",
    "admin.commission_payout.cancel": "Hủy chi trả",
    "admin.commission_payout.correction_request": "Yêu cầu điều chỉnh chi trả",
    "admin.commission_payout.correction_approve": "Duyệt điều chỉnh chi trả",

    // Lịch chi trả hoa hồng
    "admin.commission_payout_schedule.view": "Xem lịch chi trả",
    "admin.commission_payout_schedule.configure": "Thiết lập lịch chi trả",
    "admin.commission_payout_schedule.approve": "Duyệt lịch chi trả",

    // Cấu hình hoa hồng
    "admin.commission_config.view": "Xem cấu hình",
    "admin.commission_config.options": "Xem dữ liệu thiết lập",
    "admin.commission_config.detail": "Xem chi tiết cấu hình",
    "admin.commission_config.create": "Tạo cấu hình",
    "admin.commission_config.edit": "Cập nhật cấu hình",
    "admin.commission_config.create_version": "Tạo phiên bản mới",
    "admin.commission_config.history": "Xem lịch sử cấu hình",
    "admin.commission_config.status": "Cập nhật trạng thái",

    // Lịch sử phân công dịch vụ
    "admin.customer_service_staff_change.report": "Báo cáo ca không thành công",

    "admin.customer_service_commission_setup": "Thiết lập ĐK hoa hồng dịch vụ",
    "admin.customer_service_commission_setup.detail": "Xem thiết lập điều kiện hoa hồng dịch vụ",
    "admin.customer_service_commission_setup.update": "Cập nhật thiết lập điều kiện hoa hồng dịch vụ",

    "admin.customer_fund_transfer": "Chuyển tiền giữa khách hàng",
    "admin.customer_fund_transfer.view": "Xem lịch sử chuyển tiền",
    "admin.customer_fund_transfer.execute": "Thực hiện chuyển tiền",
    "admin.customer_fund_transfer.reverse": "Hoàn tác chuyển tiền",

    "admin.customer_balance": "Số dư khách hàng",
    "admin.customer_balance.apply": "Sử dụng số dư cho dịch vụ",

    // card title
    "admin.permissions": "Phân quyền",
    "admin.user": "Nhân viên",
    "admin.config": "Cài đặt chung",
    "admin.services": "Danh mục dịch vụ",
    "admin.customer_class": "Hạng khách hàng",
    "admin.relationship_types": "Mối quan hệ",
    "admin.customer_status": "Trạng thái khách hàng",
    "admin.interaction_statuses": "Trạng thái tương tác",
    "admin.interaction_types": "Loại tương tác",
    "admin.customer": "Khách hàng",
    "admin.page_manager": "Danh sách fanpage",
    "admin.branches": "Cơ sở",
    "admin.role_groups": "Nhóm vai trò",
    "admin.roles": "Vai trò",
    "admin.customer_services": "Dịch vụ",
    "admin.customer_source": "Nguồn khách hàng",
    "admin.appointment": "Lịch hẹn",
    "admin.diseases": "Danh sách bệnh",
    "admin.blood_groups": "Nhóm máu",
    "admin.product_group": "Nhóm sản phẩm",
    "admin.product": "Sản phẩm",
    "admin.product_receipt_import": "Phiếu nhập",
    "admin.product_supplier": "Nhà cung cấp",
    "admin.product_warehouse": "Danh sách kho",
    "admin.product_receipt_export": "Phiếu xuất",
    "admin.unit": "Đơn vị tính",
    "admin.product_status": "Tình trạng sản phẩm",
    "admin.guide": "Hướng dẫn sử dụng",
    "admin.work_report": "Báo cáo công việc",
    "admin.lookup_customer": "Tra cứu khách hàng",
    "admin.customer_prospect": "Khách hàng tiềm năng",
    "admin.receipt": "Phiếu thu",
    "admin.payment_voucher": "Phiếu chi",
    "admin.view_phonenumber": "Lịch sử xem số điện thoại",
    "admin.messenger": "Messenger",
    "admin.cash_book": "Sổ quỹ",
    "admin.customer_group": "Nhóm khách hàng",
    "admin.customer_payment": "Hình thức thanh toán",
    "admin.additional_cost": "Chi phí bổ sung",
    "admin.commission_rule": "Cấu hình rule hoa hồng",
    "admin.zalo": "Cài đặt Zalo OA",
    "admin.audit_logs": "Lịch sử thay đổi",
    "admin.labos": "Đối tác Labo",
    "admin.labo_cases": "Ca gửi Labo",
    "admin.statistics": "Báo cáo & Thống kê",
    "admin.branch_fund": "Quỹ cơ sở",
    "admin.partner_appointments": "Lịch hẹn",
    "admin.partner_customers": "Khách hàng đối tác",
    "admin.procedures": "Thủ thuật",
    "admin.customer_care_categories": "Danh mục chăm sóc khách hàng",
    "admin.milestones": "Quản lý ca invi",
    "admin.instruction_templates": "Mẫu lời dặn",
    "admin.prescription_templates": "Mẫu đơn thuốc",
    "admin.images": "Ảnh khách hàng",
    "admin.orthodontic_plans": "Bệnh án chỉnh nha",
    "admin.orthodontic_comments": "Bình luận chỉnh nha",
    "admin.treatment_sessions": "Phiếu điều trị",
    "admin.general_exams": "Phiếu khám tổng quát",
    "admin.orthodontic_exams": "Phiếu khám chỉnh nha",
    "admin.medical_records": "Bệnh án tổng quát",
    "admin.customer_care_logs": "Chăm sóc khách hàng",
    "admin.customer_complaints": "Phản ánh của khách hàng",
    "admin.telesale_follow_up": "Theo dõi telesale",
    "admin.feedback_requests": "Yêu cầu chỉnh sửa",
    "admin.doctor_customers": "Danh sách bệnh nhân",
    "admin.doctor_appointments": "Lịch hẹn khám",
    "admin.monitorings": "Giám sát vận hành",
    "admin.commission": "Hoa hồng",
    "admin.customer_refund": "Hoàn tiền khách hàng",
    "admin.commission_adjustment": "Điều chỉnh hoa hồng",
    "admin.commission_recovery": "Thu hồi hoa hồng",
    "admin.commission_refund": "Hoàn hoa hồng",
    "admin.commission_result": "Kết quả hoa hồng",
    "admin.commission_hold": "Hoa hồng đang giữ",
    "admin.commission_period": "Kỳ hoa hồng",
    "admin.commission_aggregate": "Tổng hợp hoa hồng",
    "admin.commission_reconciliation": "Đối soát hoa hồng",
    "admin.commission_approval": "Duyệt hoa hồng",
    "admin.commission_payout": "Chi trả hoa hồng",
    "admin.commission_payout_schedule": "Lịch chi trả hoa hồng",
    "admin.commission_config": "Cấu hình hoa hồng",
    "admin.customer_service_staff_change": "Thay đổi nhân sự",
    "admin.customer_deposit": "Quản lý tiền cọc khách hàng",
};
